import React from "react";

import RotatingIcons from "./rotating-icons";
import TeamFeatures from "./team-features";
import ProFeaturesSection from "./pro-features-section";

const AccountFeatures = ({ signupType, yearlyPrice }) => {
    return (
        <React.Fragment>
            {signupType === "pro" || signupType === "color" ? (
                <ProFeaturesSection yearlyPrice={yearlyPrice} />
            ) : (
                <RotatingIcons />
            )}
            {signupType === "team" ? <TeamFeatures /> : null}
        </React.Fragment>
    );
};

export default AccountFeatures;
